import { render, staticRenderFns } from "./SearchSpeakerTopics.vue?vue&type=template&id=edb27796&scoped=true&"
import script from "./SearchSpeakerTopics.vue?vue&type=script&lang=js&"
export * from "./SearchSpeakerTopics.vue?vue&type=script&lang=js&"
import style0 from "./SearchSpeakerTopics.vue?vue&type=style&index=0&id=edb27796&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb27796",
  null
  
)

export default component.exports